// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wLVsi","col":"styles_col__3QZZp"};